import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { Grid } from '@material-ui/core';
import PublicPage from '../PublicPage';
import Typography from '../../components/CustomTypo';
import { portalCfg } from '../../../portal.router.config';
import Button from '../../components/ButtonCustom';
import { LinkRouter } from '../../components/Link';
import 'react-phone-input-2/lib/style.css'
import { Field, Form } from 'react-final-form';
import { TextFieldComponent } from '../../components/FormElement';
import validators from '../../utils/validators';

const lang_icon_en = portalCfg.publicPath + "/icons/usa_flag.png";
const SuccessIcon = portalCfg.publicPath + "/icons/check.png";



const styles = theme => ({
    container: {
        paddingTop: theme.spacing(20),
        paddingBottom: theme.spacing(10),
        [theme.breakpoints.down('sm')]: {
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(2),
        },
    },
    marginTop: {
        marginTop: theme.spacing(4)
    },
    marginTop4x: {
        marginTop: theme.spacing(8),
    },
    marginRight: {
       marginRight: theme.spacing(4)
    },
});

function ForgotPasswordView(props) {
    const { classes, t } = props;
    return (
        <PublicPage rightComponent={<LoginViewComponent classes={classes}
            t={t}
            onForgotPassword={props.onForgotPassword}

        />} />
    );
}

function LoginViewComponent(props) {
    const { classes, t } = props;
    return (
        <Grid xs={12} sm={12} md={12} item container>
            <Grid xs={12} sm={12} item container>
                <Typography variant='h2' color='primary' mg_bottom_md>{t('forgot_password')}</Typography>
            </Grid>

            <Grid xs={12} item>
                <Typography variant='body2' color='primary'>{t('forgot_password_desc')}&nbsp;</Typography>
                
            </Grid>
            <Grid xs={12} sm={12} item container justify='center' className={classes.marginTop}>
            <Form
                onSubmit={props.onForgotPassword}
                render={({ handleSubmit, reset, submitting, pristine, values }) => (
                    <Grid xs={12} container item>
                        <Field
                            name="username"
                            component={TextFieldComponent}
                            label={t('email')}
                            placeholder={t('email_input_placeholder')}
                            isEdit={true}
                            color='default'
                            validate={validators.composeValidators(validators.validEmail)}
                            autoFocus={true}
                        />
                        <Grid xs={12} item container justify='flex-end' className={classes.marginRight}>
                            <LinkRouter to='login' variant='body2' size='sm' color='primary'>{t('btn_login')}</LinkRouter>
                        </Grid>
                        <Grid xs={12} item container justify='center' className={classes.marginTop4x}>
                            <Button color='primary' fullWidth onClick={handleSubmit}>{t('btn_submit')}</Button>
                        </Grid>
                    </Grid>
            )} />
            </Grid>
        </Grid>

    )
}

export default withStyles(styles)(withTranslation()(ForgotPasswordView));